import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import AccountsSidebar from './AccountsSidebar';
import PageFooter from './PageFooter';
import Accounts from '../pages/Accounts';
import SpecificAccountMetrics from '../pages/SpecificAccountMetrics';
import SystemMetrics from '../pages/SystemMetrics';

import brandingStyles from '../branding/brandingStyles';

class AccountsAppComponent extends Component {

    render() {
        return (
            <div id="wrapper" style={brandingStyles.backgrounds.menu}>
                <AccountsSidebar/>
                  <Route
                    path={this.props.match.url}
                    exact
                    component={Accounts}
                  />
                  <Route
                    path={`${this.props.match.url}/system`}
                    exact
                    component={SystemMetrics}
                  />
                  <Route
                    path={`${this.props.match.url}/metrics/:name/:id/:quota`}
                    exact
                    component={SpecificAccountMetrics}
                  />
                <PageFooter/>
            </div>
        );
    }
}

AccountsAppComponent.propTypes = {
    match: PropTypes.object,
};

export default AccountsAppComponent;



/** WEBPACK FOOTER **
 ** ./src/components/AccountsApp.js
 **/